export const GET_AMENITY = '[Amenity Action] Get Amenity';
export const CONFIRMED_GET_AMENITY = '[Amenity Action] Confirmed Get Amenity';
